export default __webpack_public_path__ + "static/badge-dont-2-bold-dark-d979dbfc372f9667fa5be4f78d8d38ea.png";